import { useContext } from "react";
import {  FuelListContext } from "../context";

export const useFuelList = () => useContext(FuelListContext);
